import { action, makeAutoObservable } from "mobx"
import {Locale, Currency} from "../services/constantsRegistry/models"


export enum SnackbarType{
    info = 'info',
    warning = 'warning',
    error = 'error',
    success = 'success'
}

class GeneralStore {
    pageTitle: string | Element = "";
    headerButton: () => JSX.Element | null = null;
    locale: Locale = {id: "ru"};
    currency: Currency = {id: "RUB", decimalPlaces: 2, currencyName: {"ru": "руб."}, currencyShortName: {"ru": "руб."}};


    snackbar: {
        title: string,
        description?: string,
        isOpen: boolean,
        type: SnackbarType
    } = {
        title: "",
        isOpen: false,
        type: SnackbarType.error
    };
    timer: any;


    constructor() {
        makeAutoObservable(this)
    }

    @action
    setLocale(locale: Locale){
        this.locale = locale;
    }

    @action
    setCurrency(currency: Currency){
        this.currency = currency;
    }

    @action
    setPageTitle(title, headerButton?: any){
        this.pageTitle = title;
        this.headerButton = headerButton;
    }

    @action
    showSnackbar(params: {type:SnackbarType, title: string, description?: string}){
        if(this.timer) clearTimeout(this.timer);
        const {title, type, description} = params;
        this.snackbar = {
            title: title,
            isOpen: true,
            description,
            type
        };
        this.timer = setTimeout(() => {
            this.closeSnackbar()
        }, 2000);
    }


    @action
    showSuccessSnackbar(title: string, description?: string) {
        this.showSnackbar({
            type: SnackbarType.success,
            title, description
        })
    }


    @action
    closeSnackbar(){
        this.snackbar = {
            ...this.snackbar,
            isOpen: false,
        }
    }

}

export default GeneralStore
